/* PATIKASSO FILM V3 — single frame, decoded images, no intermediate flashes */
(() => {
'use strict';
const DISPLAY_MS=2300,REVEAL_MS=170,INPUT_SETTLE_MS=135;
const cache=new Map(),reducedMotion=window.matchMedia('(prefers-reduced-motion: reduce)');
const afterPaint=()=>new Promise(done=>requestAnimationFrame(()=>requestAnimationFrame(done)));
function decodeSource(url){
  if(!url)return Promise.reject(new Error('Missing image'));
  if(cache.has(url))return cache.get(url);
  const task=new Promise((resolve,reject)=>{
    const preload=new Image();preload.decoding='async';
    preload.onload=async()=>{
      if(preload.decode)try{await preload.decode()}catch(_){}
      resolve(preload);
    };
    preload.onerror=()=>reject(new Error('Image failed'));
    preload.src=url;
  });
  cache.set(url,task);
  task.catch(()=>{if(cache.get(url)===task)cache.delete(url)});
  while(cache.size>8)cache.delete(cache.keys().next().value);
  return task;
}
function init(root){
  const sections=[];
  if(root.matches?.('[data-pf27]'))sections.push(root);
  sections.push(...root.querySelectorAll('[data-pf27]'));
  sections.forEach(section=>{
    if(section.dataset.pf27Ready==='v3')return;
    const stage=section.querySelector('[data-pf27-stage]'),
      photo=section.querySelector('[data-pf27-photo]'),
      veil=section.querySelector('[data-pf27-curtain]'),
      track=section.querySelector('[data-pf27-strip]'),
      label=section.querySelector('[data-pf27-title]'),
      count=section.querySelector('[data-pf27-index]'),
      current=section.querySelector('[data-pf27-current]'),
      progress=section.querySelector('[data-pf27-progress]'),
      thumbs=[...section.querySelectorAll('[data-pf27-thumb]')];
    if(!stage||!photo||!veil||!track||!thumbs.length)return;
    section.dataset.pf27Ready='v3';
    let active=0,requested=0,busy=false,timer=null,settleTimer=null,
      inViewport=false,dragging=null,lastWheel=0,tornDown=false;
    const total=thumbs.length,wrap=i=>(i%total+total)%total,
      source=i=>thumbs[wrap(i)].dataset.pf27Full,
      num=i=>String(i).padStart(2,'0');
    const cancelAuto=()=>{if(timer!==null)clearTimeout(timer);timer=null};
    function showMetadata(){
      thumbs.forEach((thumb,i)=>{const on=i===active;
        thumb.classList.toggle('is-current',on);
        thumb.setAttribute('aria-pressed',String(on))});
      label.textContent=thumbs[active].dataset.pf27Name||'Yaşam alanı';
      count.textContent=num(active+1)+' / '+num(total);
      if(current)current.textContent=num(active+1);
      progress.style.width=(100*(active+1)/total)+'%';
      const thumb=thumbs[active],a=thumb.getBoundingClientRect(),
        b=track.getBoundingClientRect();
      if(a.left<b.left||a.right>b.right){
        const left=track.scrollLeft+a.left-b.left-(b.width-a.width)/2;
        track.scrollTo({left:Math.max(0,left),behavior:reducedMotion.matches?'instant':'smooth'});
      }
    }
    function preloadAround(){
      [active+1,active-1].forEach(i=>decodeSource(source(i)).catch(()=>{}));
    }
    function autoNext(){
      cancelAuto();
      if(tornDown||busy||document.hidden||!inViewport||reducedMotion.matches)return;
      timer=setTimeout(()=>select(active+1,true),DISPLAY_MS);
    }
    async function processRequests(){
      if(busy)return;
      busy=true;
      try{
        while(!tornDown&&requested!==active){
          const next=requested;
          let prepared;
          try{prepared=await decodeSource(source(next))}
          catch(_){if(requested===next)requested=wrap(next+1);continue}
          if(tornDown||next!==requested)continue;
          // Cover synchronously, and keep it fully opaque for two painted frames.
          veil.style.transition='none';
          veil.style.opacity='1';
          veil.style.visibility='visible';
          await afterPaint();
          if(tornDown||next!==requested)continue;
          // Only one stage image; change its source under a fully opaque curtain.
          photo.classList.remove('is-moving');
          photo.src=prepared.src;
          photo.alt=thumbs[next].dataset.pf27Alt||'Gerçek oda yerleşimi';
          if(photo.decode)try{await photo.decode()}catch(_){}
          await afterPaint();
          if(tornDown||next!==requested)continue;
          active=next;
          showMetadata();
          void photo.offsetWidth;
          if(!reducedMotion.matches)photo.classList.add('is-moving');
          veil.style.transition=reducedMotion.matches?'none':'opacity '+REVEAL_MS+'ms ease-out';
          veil.style.opacity='0';
          await new Promise(done=>setTimeout(done,reducedMotion.matches?0:REVEAL_MS+25));
          if(requested!==active)continue;
          preloadAround();
        }
      }finally{
        if(tornDown){veil.style.opacity='0';busy=false;return}
        if(requested===active){
          veil.style.transition=reducedMotion.matches?'none':'opacity '+REVEAL_MS+'ms ease-out';
          veil.style.opacity='0';
        }
        busy=false;
        if(requested!==active)processRequests();else autoNext();
      }
    }
    function select(n,immediate=false){
      requested=wrap(n);
      cancelAuto();
      clearTimeout(settleTimer);
      // Multiple rapid clicks coalesce into the last desired frame.
      if(immediate)processRequests();
      else settleTimer=setTimeout(()=>processRequests(),INPUT_SETTLE_MS);
    }
    thumbs.forEach((thumb,i)=>thumb.addEventListener('click',()=>select(i)));
    section.querySelector('[data-pf27-prev]')?.addEventListener('click',()=>select(requested-1));
    section.querySelector('[data-pf27-next]')?.addEventListener('click',()=>select(requested+1));
    stage.addEventListener('keydown',e=>{
      if(e.key==='ArrowRight'){e.preventDefault();select(requested+1)}
      if(e.key==='ArrowLeft'){e.preventDefault();select(requested-1)}
    });
    stage.addEventListener('pointerdown',e=>{
      if(e.pointerType==='mouse'&&e.button!==0)return;
      dragging={x:e.clientX,y:e.clientY,id:e.pointerId};
    });
    stage.addEventListener('pointerup',e=>{
      if(!dragging||dragging.id!==e.pointerId)return;
      const dx=e.clientX-dragging.x,dy=e.clientY-dragging.y;
      dragging=null;
      if(Math.abs(dx)>42&&Math.abs(dx)>Math.abs(dy)*1.3)
        select(requested+(dx<0?1:-1));
    });
    stage.addEventListener('pointercancel',()=>dragging=null);
    stage.addEventListener('dragstart',e=>e.preventDefault());
    stage.addEventListener('wheel',e=>{
      const now=Date.now();
      if(Math.abs(e.deltaX)>24&&Math.abs(e.deltaX)>Math.abs(e.deltaY)*1.2&&now-lastWheel>430){
        e.preventDefault();lastWheel=now;
        select(requested+(e.deltaX>0?1:-1));
      }
    },{passive:false});
    const observer='IntersectionObserver'in window?new IntersectionObserver(entries=>{
      inViewport=Boolean(entries[0]?.isIntersecting);
      if(inViewport)autoNext();else cancelAuto();
    },{threshold:.1}):null;
    if(observer)observer.observe(section);else inViewport=true;
    const onVisibility=()=>{if(document.hidden)cancelAuto();else autoNext()};
    document.addEventListener('visibilitychange',onVisibility);
    document.addEventListener('shopify:section:unload',e=>{
      if(!e.target.contains(section))return;
      tornDown=true;cancelAuto();clearTimeout(settleTimer);
      observer?.disconnect();
      document.removeEventListener('visibilitychange',onVisibility);
    });
    showMetadata();preloadAround();
    if(!observer)autoNext();
  });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document));
else init(document);
document.addEventListener('shopify:section:load',e=>init(e.target));
})();
